export const getCurrencySign = (currencyCode: string): string => {
  const currencyMap: Record<string, string> = {
    NGN: '₦',
    EUR: '€',
    USD: '$',
    GBP: '£',
    CAD: 'C$',
    XOF: 'CFA',
    XAF: 'CFA',
    GHS: 'GH₵',
    CNY: '¥', // Correcting "CHY" to "CNY" for Chinese Yuan
  };

  return currencyMap[currencyCode.toUpperCase()] || currencyCode;
};

export const maskEmail = (email: string) => {
  const [username, domain] = email.split('@');
  if (!username || !domain) return email; // Return as is if invalid

  const maskedUsername =
    username.length > 2
      ? username[0] + '*'.repeat(username.length - 2) + username.slice(-1)
      : username[0] + '*';

  const [domainName, domainExt] = domain.split('.');
  const maskedDomain =
    domainName.length > 2
      ? domainName[0] + '*'.repeat(domainName.length - 2) + domainName.slice(-1)
      : domainName[0] + '*';

  return `${maskedUsername}@${maskedDomain}.${domainExt}`;
};

export const toTitleCaseFromUnderscore = (str: string) => {
  return str
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const toUnderscoreFromTitleCase = (str: string) => {
  return str
    .split(' ')
    .map((word) => word.toLowerCase())
    .join('_')
    .toUpperCase();
};
